import { render, staticRenderFns } from "./Uitschrijven.vue?vue&type=template&id=0d18b744&scoped=true"
import script from "./Uitschrijven.vue?vue&type=script&lang=js"
export * from "./Uitschrijven.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18b744",
  null
  
)

export default component.exports